// GENERATED FILE - DO NOT MODIFY

export enum GetFoodMerchantsSortColumnDto {
    Order = "Order",
    Name = "Name",
}